import GLightbox from 'glightbox';

Drupal.behaviors.glightbox = {
  attach(context) {
    GLightbox();
  },
};
